import script from "./colorcardAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./colorcardAdd.vue?vue&type=script&setup=true&lang=js"

import "./colorcardAdd.vue?vue&type=style&index=0&id=279e3353&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-279e3353"]])

export default __exports__